import { useCallback } from 'react';
import { useTranslation } from '@/feature/lang';

export const useUnitLabel = () => {
  const { texts, translate } = useTranslation();
  const unitTexts = texts.common.unit;

  return useCallback(
    (unit: string | undefined, options?: { count?: number | null }) => {
      const count = options?.count ?? undefined;

      switch (unit) {
        // Time
        case 'h':
          return translate(unitTexts.time.hour.short);
        case 's':
          return translate(unitTexts.time.second.short);
        case 'day':
          return translate(unitTexts.time.day, undefined, count);
        case 'timestamp':
        case 'date':
        case 'duration':
          return '';

        // Temperature
        case 'Cel':
          return translate(unitTexts.temperature.celsius);
        case 'degF':
          return translate(unitTexts.temperature.fahrenheit);

        // Power
        case 'kW':
          return translate(unitTexts.power.kW);
        case '[HP]':
          return translate(unitTexts.power.hp);

        // Pressure
        case 'MPa':
          return translate(unitTexts.pressure.MPa);
        case '[psi]':
          return translate(unitTexts.pressure.psi);

        // Length
        case 'mm':
          return translate(unitTexts.length.mm);
        case '[in_i]':
          return translate(unitTexts.length.inch);

        // Mass
        case 'kg':
          return translate(unitTexts.weight.kg);

        // Angle
        case 'deg':
          return translate(unitTexts.angle.degree);

        // Rotational speed
        case '1/min':
          return translate(unitTexts.rotationalSpeed.rpm);

        // Level
        case 'dB':
          return translate(unitTexts.level.dB);

        // Ratio
        case 'pp':
          return translate(unitTexts.ratio.percentagePoint);

        // Acceleration:
        case '[g]':
        case 'm/s2': // Likely incorrect, but needed at time of writing as ucum code is set to "m/s2" for a number of signals
          return translate(unitTexts.acceleration.g);

        case '1':
          return '';
        default:
          return unit;
      }
    },
    [translate, unitTexts]
  );
};
